import { useStoreContext } from "@/context";
import { Actions } from "@/context/reducer";
import { SnackbarType } from "@/decleration";

const useSnackbar = () => {
  const { dispatch } = useStoreContext();
  const setSnackbar = (data: SnackbarType) => {
    dispatch({ type: Actions.SNACKBAR, payload: data });
  };

  const close = () => {
    dispatch({
      type: Actions.SNACKBAR,
      payload: {
        open: false,
        message: "",
        content: null,
        type: "",
        // onClose: () => ({}),
      },
    });
  };
  return { setSnackbar, close };
};

export default useSnackbar;
